(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coobber-packaging-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('coobber-packaging-dialog');
    const opener = document.querySelector('[data-coobber-packaging-open]');
    if (!dialog || !opener || typeof dialog.showModal !== 'function') return;
    const key = 'coobber-packaging-v1';
    opener.hidden = false;
    opener.addEventListener('click', () => dialog.showModal());
    dialog.addEventListener('close', () => {
      try { sessionStorage.setItem(key, 'seen'); } catch (_) {}
      opener.focus({preventScroll:true});
    });
    let seen = false;
    try { seen = sessionStorage.getItem(key) === 'seen'; } catch (_) {}
    if (!seen) dialog.showModal();
  })();
  } catch(e) { console.error(e); }
})();

})();
